import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

export const superAdminGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (!authService.isAuthenticated()) {
    router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
    return false;
  }

  if (!authService.isSuperAdmin()) {
    const list = state.url.startsWith('/admin/roles') ? '/admin/roles' : '/admin/users';
    router.navigate([list]);
    return false;
  }

  return true;
};
